var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraBlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7ad795312a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 76439718000000000
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 100.757812 0 30.4375 70.320312 30.4375 157.0625 C 30.4375 243.804688 100.757812 314.125 187.5 314.125 C 274.242188 314.125 344.5625 243.804688 344.5625 157.0625 C 344.5625 70.320312 274.242188 0 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "962e3e9a7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.125 270.328125 L 296 270.328125 L 296 375 L 79.125 375 Z M 79.125 270.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1102205f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 375 L 295.875 270.328125 L 79.125 270.328125 L 187.5 375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5271bb2875"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d2daeac72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 8.738281 C 104.800781 8.738281 37.757812 75.78125 37.757812 158.480469 C 37.757812 241.179688 104.800781 308.222656 187.5 308.222656 C 270.199219 308.222656 337.242188 241.179688 337.242188 158.480469 C 337.242188 75.78125 270.199219 8.738281 187.5 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb7e7ce339"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.175781 266.46875 L 291 266.46875 L 291 367 L 84.175781 367 Z M 84.175781 266.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "376e080cac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 366.261719 L 290.824219 266.46875 L 84.175781 266.46875 L 187.5 366.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b734b5a68b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84e68ba68d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 19.507812 C 110.746094 19.507812 48.527344 81.726562 48.527344 158.480469 C 48.527344 235.234375 110.746094 297.453125 187.5 297.453125 C 264.253906 297.453125 326.472656 235.234375 326.472656 158.480469 C 326.472656 81.726562 264.253906 19.507812 187.5 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96015f9a5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101.90625 85 L 216 85 L 216 208 L 101.90625 208 Z M 101.90625 85 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e54f27f614"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102 71.664062 L 272.90625 71.664062 L 272.90625 242.117188 L 102 242.117188 Z M 102 71.664062 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ad795312a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76439718e9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#962e3e9a7c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1102205f6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 79.125 270.328125 L 296.183594 270.328125 L 296.183594 374.792969 L 79.125 374.792969 Z M 79.125 270.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5271bb2875)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d2daeac72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb7e7ce339)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#376e080cac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 84.175781 266.46875 L 291.117188 266.46875 L 291.117188 366.066406 L 84.175781 366.066406 Z M 84.175781 266.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b734b5a68b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84e68ba68d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96015f9a5f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 125.5 120.773438 C 129.808594 120.773438 133.242188 124.1875 133.242188 128.5 C 133.242188 132.828125 129.808594 136.242188 125.5 136.242188 C 121.171875 136.242188 117.753906 132.828125 117.753906 128.5 C 117.753906 124.1875 121.171875 120.773438 125.5 120.773438 Z M 152.324219 162.355469 C 151.957031 160.546875 151.777344 158.757812 151.777344 156.78125 C 151.777344 138.230469 166.730469 123.292969 185.265625 123.292969 C 187.074219 123.292969 189.046875 123.460938 190.851562 123.824219 L 215.339844 99.15625 L 211.195312 90.699219 C 209.585938 87.449219 206.335938 85.476562 202.738281 85.476562 L 167.625 85.476562 C 164.027344 85.476562 160.777344 87.449219 159.15625 90.699219 L 152.140625 104.742188 L 120.09375 104.742188 C 110.011719 104.925781 101.90625 113.199219 101.90625 123.113281 L 101.90625 193.6875 C 101.90625 198.910156 104.0625 203.585938 107.675781 207.003906 L 152.324219 162.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e54f27f614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 218.589844 156.769531 C 218.589844 175.320312 203.636719 190.257812 185.082031 190.257812 C 179.332031 190.257812 174.109375 188.816406 169.417969 186.296875 L 214.625 141.117188 C 217.144531 145.792969 218.589844 151.015625 218.589844 156.769531 Z M 270.613281 73.953125 C 267.546875 70.886719 262.507812 70.886719 259.273438 73.953125 L 104.972656 228.4375 C 101.90625 231.488281 101.90625 236.53125 104.972656 239.777344 C 106.582031 241.402344 108.570312 242.117188 110.542969 242.117188 C 112.535156 242.117188 114.6875 241.402344 116.132812 239.777344 L 143.851562 212.058594 L 250.4375 212.058594 C 260.535156 212.058594 268.625 203.949219 268.625 193.871094 L 268.625 123.113281 C 268.625 113.199219 260.699219 105.105469 250.804688 104.925781 L 270.613281 85.113281 C 273.679688 82.0625 273.679688 77.023438 270.613281 73.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlocked);
export default __webpack_public_path__ + "static/media/camera_blocked.6b6916e6003152dfcccf5d592c1c7af7.svg";
export { ForwardRef as ReactComponent };